import Enum from "@/util/enum";
import EnumValue from ".";

export default class Rh extends Enum {
  static UNKNOWN: EnumValue = { name: "Unknown", code: "?" };
  static PLUS: EnumValue = { name: "+", code: "+" };
  static MINUS: EnumValue = { name: "-", code: "-" };
}
